import { render, staticRenderFns } from "./F105.vue?vue&type=template&id=994b5f12&scoped=true"
import script from "./F105.vue?vue&type=script&lang=js"
export * from "./F105.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=994b5f12&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994b5f12",
  null
  
)

export default component.exports